const notFound = () =>
  import ('@/pc/views/base/notFound');
const claim = () =>
  import ('@/pc/views/claimStore');
const help = () =>
  import ('@/pc/views/base/help');
const aboutUs = () =>
  import ('@/pc/views/base/aboutUs');
const merchantAgreement = () =>
  import ('@/pc/views/base/merchantAgreement');
const userAgreement = () =>
  import ('@/pc/views/base/userAgreement');
const notice = () =>
  import ('@/pc/views/base/notice');

const inviteAssistant = () =>
  import ('@/pc/views/inviteAssistant');







export default [{
  path: '/',
  redirect: '/login'
}, {
  path: '/login',
  redirect: '/claim'
}, { // 认领门店
  path: '/claim',
  component: claim
}, { // 找回密码
  path: '/findPassword',
  redirect: '/login'
}, {
  path: '/notFound',
  name: 'notFound',
  component: notFound
}, {
  path: '/help',
  name: 'help',
  component: help
}, {
  path: '/aboutUs',
  name: 'aboutUs',
  component: aboutUs
}, {
  path: '/agreement/admission',
  name: 'agreementAdmission',
  component: merchantAgreement
}, {
  path: '/agreement/user',
  name: 'agreementUser',
  component: userAgreement
}, {
  path: '/invite-assistant',
  name: 'invite-assistant',
  component: inviteAssistant
}, {
  path: '/notice',
  name: 'notice',
  component: notice
}, {
  path: '/announcement',
  name: 'announcement',
  component: notice
}]



// WEBPACK FOOTER //
// ./src/router/pc/base.js